import { JobStatusSummaryItem } from "./job-status-summary-item.model";
import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IJobStatusSummaryArgs extends IAccountObjectArgs {
    items?: Array<JobStatusSummaryItem>;
}

const defaults = () => {
    return {
        items: []
    };
};

export class JobStatusSummary extends AccountObject {
    items: Array<JobStatusSummaryItem>;

    constructor(data?: IJobStatusSummaryArgs) {
        super({...defaults(), ...data} as any);
    }

    getTotal(): number {
        return this.items.map(item => item.count).reduce((p, c) => {
            return p + c;
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status-summary-item/job-status-summary.model.ts